exports.f = require('./_wks');


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/modules/_wks-ext.js
 ** module id = 264
 ** module chunks = 2 4 6 8 9 11 12
 **/